export default __webpack_public_path__ + "static/media/MyHouse_08.6a4dcafd.png";